import moment from 'moment-timezone';
import { DEFAULT_USER_LOCALE, DEFAULT_TIME_ZONE } from '../utils/appConstants';
import { getLocalStorage } from '../utils/util';

/**
 * 
 * @param {String} items => Array of objects
 * @param {String} key => Object's key for Date value
 * @param {Boolean} isAscending => true (Ascending) or false (Descending) order.
 
* Sort the items by date
 */
export function sortByDate(items, key, isAscending) {
  items.sort((nextItem, previousItem) => {
    return isAscending ? moment(nextItem[key]).diff(previousItem[key]) : moment(previousItem[key]).diff(nextItem[key]);
  });
  return items;
}

/**
 * 
 * @param {String} items => Array of objects
 * @param {String} key => Object's key for Date value
 
* format the date vales in array of objects 
 */
export function formatDateArrayOfObject(items, key) {
  let results = [];
  const length = items.length;
  for (let index = 0; index < length; index++) {
    let item = items[index];
    if (item && item[key]) {
      item[key] = formatDateString(item[key]);
    }
    results.push(item);
  }
  return results;
}

/**
 * 
 * @param {String} dateString => date value in String
 * @param {String} format => Date display format
 * @param {String} timeZone => User time-zone
 
* format the date value to user time-zone.
 */
export function formatDateString(dateString) {
  const orgUserInfo = getLocalStorage('sourceOrganizationInfo');
  let orgUserLocale = DEFAULT_USER_LOCALE;
  let orgUserTimezone = DEFAULT_TIME_ZONE;
  if (orgUserInfo) {
    const storage = JSON.parse(orgUserInfo);
    const {
      userInfo: {
        userLocale,
        timeZone
      }
    } = storage;
    if (userLocale) {
      orgUserLocale = userLocale.replace('_', '-');
    }
    orgUserTimezone = timeZone;
  } else {
    orgUserLocale = navigator.language;
  }
  const lmd = new Date(dateString);
  const options = {
    timeZone: orgUserTimezone,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  let formattedDate = lmd.toLocaleDateString(orgUserLocale, options);
  if (formattedDate) {
    formattedDate = formattedDate.toUpperCase();
  }
  return formattedDate;
}
export function formatDate(dateString) {
  const localeDateFormat = getDateLocaleFormat();
  let momentDateFormat;
  if (localeDateFormat) {
    momentDateFormat = moment(Date.parse(dateString)).format(localeDateFormat.toUpperCase());
  }
  const delimeter = getDelimiterFromLocaleDateFormat(localeDateFormat);
  let formattedDate;
  if (momentDateFormat && localeDateFormat) {
    formattedDate = formatLocaleDate(momentDateFormat, localeDateFormat, delimeter);
  }
  return formattedDate;
}
export function getDateLocaleFormat() {
  const orgUserInfo = getLocalStorage('sourceOrganizationInfo');
  let orgUserLocale = DEFAULT_USER_LOCALE;
  if (orgUserInfo) {
    const storage = JSON.parse(orgUserInfo);
    const {
      userInfo: {
        userLocale
      }
    } = storage;
    if (userLocale) {
      orgUserLocale = userLocale.replace('_', '-');
    }
  } else {
    orgUserLocale = navigator.language;
  }
  const map = getLocaleDateMap();
  const localeDateFormat = map.get(orgUserLocale);
  return localeDateFormat;
}
export function formatLocaleDate(dateInput, dateFormat, delimiter) {
  const formatLowerCase = dateFormat !== undefined ? dateFormat.toLowerCase() : 'dd/MM/yyyy';
  const formatItems = formatLowerCase.split(delimiter);
  const dateItems = dateInput.split(delimiter);
  const monthIndex = formatItems.indexOf("mm");
  const dayIndex = formatItems.indexOf("dd");
  const yearIndex = formatItems.indexOf("yyyy");
  let year = parseInt(dateItems[yearIndex]);
  if (year < 100) {
    year += 2000;
  }
  let month = parseInt(dateItems[monthIndex]);
  month -= 1;
  const formatedDate = new Date(year, month, dateItems[dayIndex]);
  return formatedDate;
}
export function getDelimiterFromLocaleDateFormat(dateString) {
  const delimiterPattern = /[^a-zA-Z0-9]/g;
  let matches;
  if (dateString) {
    matches = dateString.match(delimiterPattern);
  }
  if (matches) {
    const uniqueDelimiters = [...new Set(matches)];
    if (uniqueDelimiters.length > 0) {
      return uniqueDelimiters[0];
    }
  }
  return null;
}
export function getLocaleDateMap() {
  const map = new Map();
  map.set('ar', 'dd/MM/yyyy');
  map.set('ar-AE', 'dd/MM/yyyy');
  map.set('ar-BH', 'dd/MM/yyyy');
  map.set('ar-JO', 'dd/MM/yyyy');
  map.set('ar-KW', 'dd/MM/yyyy');
  map.set('ar-LB', 'dd/MM/yyyy');
  map.set('ar-SA', 'dd/MM/yyyy');
  map.set('bg-BG', 'yyyy-MM-dd');
  map.set('ca', 'dd/MM/yyyy');
  map.set('ca-ES', 'dd/MM/yyyy');
  map.set('ca-ES-EURO', 'dd/MM/yyyy');
  map.set('cs', 'dd.MM.yyyy');
  map.set('cs-CZ', 'dd.MM.yyyy');
  map.set('da', 'dd-MM-yyyy');
  map.set('da-DK', 'dd-MM-yyyy');
  map.set('de', 'dd.MM.yyyy');
  map.set('de-AT', 'dd.MM.yyyy');
  map.set('de-AT-EURO', 'dd.MM.yyyy');
  map.set('de-CH', 'dd.MM.yyyy');
  map.set('de-DE', 'dd.MM.yyyy');
  map.set('de-DE-EURO', 'dd.MM.yyyy');
  map.set('de-LU', 'dd.MM.yyyy');
  map.set('de-LU-EURO', 'dd.MM.yyyy');
  map.set('el-GR', 'dd/MM/yyyy');
  map.set('en-AU', 'dd/MM/yyyy');
  map.set('en-B', 'MM/dd/yyyy');
  map.set('en-BM', 'MM/dd/yyyy');
  map.set('en-CA', 'dd/MM/yyyy');
  map.set('en-GB', 'dd/MM/yyyy');
  map.set('en-GH', 'MM/dd/yyyy');
  map.set('en-ID', 'MM/dd/yyyy');
  map.set('en-IE', 'dd/MM/yyyy');
  map.set('en-IE-EURO', 'dd/MM/yyyy');
  map.set('en-NZ', 'dd/MM/yyyy');
  map.set('en-SG', 'MM/dd/yyyy');
  map.set('en-US', 'MM/dd/yyyy');
  map.set('en-ZA', 'yyyy/MM/dd');
  map.set('es', 'dd/MM/yyyy');
  map.set('es-AR', 'dd/MM/yyyy');
  map.set('es-BO', 'dd-MM-yyyy');
  map.set('es-CL', 'dd-MM-yyyy');
  map.set('es-CO', 'dd/MM/yyyy');
  map.set('es-CR', 'dd/MM/yyyy');
  map.set('es-EC', 'dd/MM/yyyy');
  map.set('es-ES', 'dd/MM/yyyy');
  map.set('es-ES-EURO', 'dd/MM/yyyy');
  map.set('es-GT', 'dd/MM/yyyy');
  map.set('es-HN', 'MM-dd-yyyy');
  map.set('es-MX', 'dd/MM/yyyy');
  map.set('es-PE', 'dd/MM/yyyy');
  map.set('es-PR', 'MM-dd-yyyy');
  map.set('es-PY', 'dd/MM/yyyy');
  map.set('es-SV', 'MM-dd-yyyy');
  map.set('es-UY', 'dd/MM/yyyy');
  map.set('es-VE', 'dd/MM/yyyy');
  map.set('et-EE', 'dd.MM.yyyy');
  map.set('fi', 'dd.MM.yyyy');
  map.set('fi-FI', 'dd.MM.yyyy');
  map.set('fi-FI-EURO', 'dd.MM.yyyy');
  map.set('fr', 'dd/MM/yyyy');
  map.set('fr-BE', 'dd/MM/yyyy');
  map.set('fr-CA', 'yyyy-MM-dd');
  map.set('fr-CH', 'dd.MM.yyyy');
  map.set('fr-FR', 'dd/MM/yyyy');
  map.set('fr-FR-EURO', 'dd/MM/yyyy');
  map.set('fr-LU', 'dd/MM/yyyy');
  map.set('fr-MC', 'dd/MM/yyyy');
  map.set('hr-HR', 'yyyy.MM.dd');
  map.set('hu', 'yyyy.MM.dd.');
  map.set('hy-AM', 'MM/dd/yyyy');
  map.set('is-IS', 'dd.MM.yyyy');
  map.set('it', 'dd/MM/yyyy');
  map.set('it-CH', 'dd.MM.yyyy');
  map.set('it-IT', 'dd/MM/yyyy');
  map.set('iw', 'dd/MM/yyyy');
  map.set('iw-IL', 'dd/MM/yyyy');
  map.set('ja', 'yyyy/MM/dd');
  map.set('ja-JP', 'yyyy/MM/dd');
  map.set('kk-KZ', 'MM/dd/yyyy');
  map.set('km-KH', 'MM/dd/yyyy');
  map.set('ko', 'yyyy. MM. dd');
  map.set('ko-KR', 'yyyy. MM. dd');
  map.set('lt-LT', 'yyyy.MM.dd');
  map.set('lv-LV', 'yyyy.dd.MM');
  map.set('ms-MY', 'dd/MM/yyyy');
  map.set('nl', 'dd-MM-yyyy');
  map.set('nl-BE', 'dd/MM/yyyy');
  map.set('nl-NL', 'dd-MM-yyyy');
  map.set('nl-SR', 'dd-MM-yyyy');
  map.set('no', 'dd.MM.yyyy');
  map.set('no-NO', 'dd.MM.yyyy');
  map.set('pl', 'yyyy-MM-dd');
  map.set('pt', 'dd-MM-yyyy');
  map.set('pt-AO', 'dd-MM-yyyy');
  map.set('pt-BR', 'dd/MM/yyyy');
  map.set('pt-PT', 'dd-MM-yyyy');
  map.set('ro-RO', 'dd.MM.yyyy');
  map.set('ru', 'dd.MM.yyyy');
  map.set('sk-SK', 'dd.MM.yyyy');
  map.set('sl-SI', 'dd.MM.y');
  map.set('sv', 'yyyy-MM-dd');
  map.set('sv-SE', 'yyyy-MM-dd');
  map.set('th', 'MM/dd/yyyy');
  map.set('th-TH', 'dd/MM/yyyy, ?.');
  map.set('tr', 'dd.MM.yyyy');
  map.set('ur-PK', 'MM/dd/yyyy');
  map.set('vi-VN', 'dd/MM/yyyy');
  map.set('zh', 'yyyy-MM-dd');
  map.set('zh-CN', 'yyyy-MM-dd');
  map.set('zh-HK', 'yyyy-MM-dd');
  map.set('zh-TW', 'yyyy/MM/dd');
  return map;
}